<template>
  <b-container>
    <b-row>
      <DocumentUpload ref="documentUpload"  v-model="uploadDocument"></DocumentUpload>
      <b-form-group label="Data di Firma" style="margin-top: 20px;" class="col-md-12">
        <DatePicker ref="signedAt" id="signed-at" description="Data di firma" v-model="signedAt" :required="true"
                    :not-after-today="true"/>
      </b-form-group>
    </b-row>
    <b-row align-h="end" class="mr-2">
      <b-button @click="switchTab" id="fill-documents-button" variant="primary">Conferma</b-button>
    </b-row>
  </b-container>
</template>

<script>
import eventBus from "@/EventBus";
import DatePicker from "@/components/DatePicker.vue";
import DocumentUpload from "@/components/digitalization/DocumentUpload.vue";

export default {
  name: 'Summary',
  components: {DocumentUpload, DatePicker},
  provide() {
    return {parentValidator: this.$validator}
  },
  created() {
    eventBus.$on('reset-state', () => {
      this.uploadDocument = {}
      this.$refs['signedAt'].reset()
      this.$refs['documentUpload'].reset()
      this.$validator.reset()
    })
  },
  data: () => ({
    uploadDocument: {},
    signedAt: null
  }),
  methods: {
    switchTab() {
      this.$validator.validateAll().then(result => {
        if (result) {
          eventBus.$emit("switch-tab", 3)
          eventBus.$emit("documents-data-filled", {
            frontPicture: this.uploadDocument.frontPicture,
            backPicture: this.uploadDocument.backPicture,
            dataEntryMode: 'DIGITALIZED_MANUAL',
            signedAt: this.signedAt,
            frontPdf: this.uploadDocument.frontPdf,
            backPdf: this.uploadDocument.backPdf
          })
        }
      })
    }
  }
}
</script>
